import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client, Subscriber } from '../interfaces/person.interface';
import { environment } from '../../environments/environment';
import { CardContent, GaugingFull } from '../interfaces/gauging.interface';
import { AccountService } from './account.service';
import { Microroute } from '../interfaces/dashboard.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private url = `${environment.api_url}/aforo/app`;
  private subs_info: CardContent | null = null;

  constructor(private accountSvc: AccountService, private http: HttpClient) {}

  getMicroroutes(): Observable<Microroute[]> {
    let headers = this.accountSvc.headers;
    return this.http.get<Microroute[]>(`${this.url}/microroutes/`, { headers });
  }
}
